var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 22,
    fill: "currentColor",
    viewBox: "0 0 8 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.999.69c.634 0 1.171.226 1.61.675.44.44.66.971.66 1.596 0 .625-.225 1.158-.674 1.597-.44.44-.971.66-1.596.66-.625 0-1.158-.22-1.597-.66-.44-.44-.66-.972-.66-1.597s.22-1.157.66-1.596A2.15 2.15 0 0 1 3.999.691Zm2.05 6.637V18.18c0 .967.113 1.587.337 1.86.225.264.664.415 1.319.455v.527H.307v-.527c.606-.02 1.055-.196 1.348-.528.195-.224.293-.82.293-1.787v-7.998c0-.967-.113-1.582-.337-1.846-.225-.273-.66-.43-1.304-.468v-.542H6.05Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.1ccd640075dda7f0735f091838620330.svg";
export { ForwardRef as ReactComponent };